import {Box} from '@viptech/react-components'
import sub from 'date-fns/sub'
import moment from 'moment'
import {useState} from 'react'
import ReactJson from 'react-json-view'
import CustomCalendar from 'src/components/customCalendar/CustomCalendar'
import RowHover from 'src/components/RowHover/RowHover'
import {useCameraConfigContext} from 'src/pages/camera-config/context/CameraConfigContext'
import LoadMoreButton from '../../../../components/Button/LoadMoreButton'
import useCameraHistory from '../../../../hooks/api/camera/useCameraHistory'
import {cameraFormatRows, cameraHistoryColumns, diffJson} from './CameraConfigHistoricFunctions'
import {FilterDate} from './components/camera-historic-filter/CameraFilterProps'
import Table from 'src/components/table/Table'
import TableData from 'src/components/table/components/tableData'

const CameraConfigHistory = () => {
  const [filterDate, setFilterDate] = useState<FilterDate>({
    from: moment(sub(new Date(), {minutes: 30})).format(),
    to: moment(new Date()).format(),
  })

  const {camera} = useCameraConfigContext()

  const {
    data: cameraHistory,
    isLoading: loadingCameraStatus,
    fetchNextPage,
  } = useCameraHistory({
    filter: {
      cameraId: camera!.id,
    },
    from: filterDate.from,
    to: filterDate.to,
  })

  const handleChangeTimeStart = (dates: [Date, Date]) => {
    let from = moment(dates[0]).format()
    let to = moment(dates[1]).format()
    if (dates[0] === dates[1]) {
      from = moment(dates[0].setHours(0, 0, 0, 0)).format()
      to = moment(dates[1].setHours(23, 59, 59, 59)).format()
    }
    setFilterDate({
      from,
      to,
    })
  }

  return (
    <Box display='flex' width='100%' direction='column' rowGap='20px'>
      <Box display='flex' width='100%' justifyContent='flex-end'>
        <CustomCalendar setDate={handleChangeTimeStart} />
      </Box>

      <Table isLoading={loadingCameraStatus} columns={cameraHistoryColumns} skeletonRowsAmount={20}>
        {cameraHistory &&
          cameraFormatRows(cameraHistory.pages.flatMap((it) => it.entities.flatMap((it) => it))).map((row, index) => (
            <RowHover key={index}>
              <TableData>{row.updatedAt}</TableData>
              <TableData>{row.lastUpdate}</TableData>
              <TableData>{row.userName}</TableData>
              <TableData>
                <ReactJson
                  src={diffJson(JSON.parse(row.beforeChange), JSON.parse(row.afterChange)).previous}
                  name={'camera'}
                  displayObjectSize={false}
                  displayDataTypes={false}
                />
              </TableData>
              <TableData>
                <ReactJson
                  src={diffJson(JSON.parse(row.beforeChange), JSON.parse(row.afterChange)).modified}
                  name={'camera'}
                  displayObjectSize={false}
                  displayDataTypes={false}
                />
              </TableData>
            </RowHover>
          ))}
      </Table>

      <Box display='flex' justifyContent='center' marginTop='15px' width='100%'>
        <LoadMoreButton onClick={() => fetchNextPage()} isLoading={loadingCameraStatus} />
      </Box>
    </Box>
  )
}

export default CameraConfigHistory
